export default __webpack_public_path__ + "static/media/314.dbfa167a.png";